import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { getUsers } from './actions'
import App from '../common/app'
import Users from './components/index'
let unsubscribe = function () {}

function render () {
  renderWithRoot(
    <App active="cart" {...getState()} {...appActions}>
      <Users {...getState()} getUsers={getUsers} />
    </App>,
    document.querySelector('#app')
  )
}

export function enter (context, next) {
  unsubscribe = subscribe(render)
  getUsers()
  render()
}

export function exit (context, next) {
  unsubscribe()
  next()
}
